import React, {useEffect, useState} from "react";
import AziendaNavContainer from "../../features/azienda/AziendaNavContainer";
import Loading from "../../components/dataTable/Loading";
import DisclosureEx from "../../components/DisclosureEx";
import PeriodoRif from "../../components/PeriodoRif";
import {TaskUploadRML} from "@commons/mapping/TaskUploadRML";
import * as Validation from "@utilities/validationRules";
import RadioInput from "../../components/RadioInput";
import CheckboxEx from "../../components/wrapperComponents/CheckboxEx";
import {useUploadFileMutation} from "@commons/features/PVA/uploadRetribuzioni.api";
import {useForm} from "react-hook-form";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectToken} from "@commons/core.slice";
import {FileDropZone} from "./comps/FileDropZone";
import {bool2String} from "@commons/utils/util";
import {TokenRecord} from "@commons/mapping/TokenRecord";
import {IconUpload} from "@tabler/icons-react";

const ImportPVA: React.FC = () => {
    const token: TokenRecord | null = useAppSelector(selectToken);
    const defaultValues: TaskUploadRML = {anno: token.anno, mese: token.mese, noCessati: true} as TaskUploadRML;
    const {handleSubmit, register, control, reset, watch, setValue, formState: {errors}} = useForm<TaskUploadRML>({defaultValues});
    const tipoFileSel = watch('tipoFile');
    const selPrimoImport = watch('primoImport');

    useEffect(() => {
        if (tipoFileSel === 'NATIVO_STORICO_ANNO') {
            setValue('mese', 0);
            setValue('anno', token.anno);
        } else {
            setValue('mese', token.mese);
            setValue('anno', token.anno);
        }
    }, [token.anno, token.mese, tipoFileSel]);

    const [uploadFile, {isError, error, data}] = useUploadFileMutation();
    const [selectedFile, setSelectedFile] = useState<File[]>([]);

    function onSubmit(data: TaskUploadRML) {
        //console.log(data);
        const formData = new FormData();
        // Dal vecchio e buon FPNet... [{anno: resource.anno, mese: resource.mese, format: resource.tipoFile}];
        formData.append('anno', Number(data.anno).toString());
        formData.append('mese', Number(data.mese).toString());
        formData.append('format', data.tipoFile!);

        formData.append('noCessati', bool2String(data.noCessati) ?? 'true');
        formData.append('primoImport', bool2String(data.primoImport) ?? 'false');
        formData.append('fissaRMLVariate', bool2String(data.fissaRMLVariate) ?? 'false');

        formData.append("file", selectedFile[0]);

        uploadFile({formData, idAziendaMaster: token!.idAziendaMaster, idAzienda: token!.idAzienda}).then(() => {
        });

    }

    return (
        <Loading loading={false}>
            <AziendaNavContainer>
                <div className="bg-white rounded-md px-2 mt-4 py-5">

                    {/*rotta upload http://fpnet.local/FPNet2021/servizio/67-68/upload/rml?auth_token=9854c3cf4d6c502869f5044845a1f9bc*/}
                    <DisclosureEx accordionColor="bg-sky-400 hover:bg-sky-500" accordionTitle="Acquisizione retribuzioni"
                                  accordionState={true}
                                  submitButtonText={<><IconUpload className="h-5 w-5"/><span>&nbsp;Carica</span></>}
                                  btnDisabled={selectedFile.length === 0 || selectedFile[0] === undefined}
                                  formSubmit={(e) => {
                                      handleSubmit(onSubmit)(e).catch(() => {
                                      })
                                  }}
                    >
                        <>
                            <div>
                                <PeriodoRif control={control} register={register} errors={errors}
                                            nameAnno="anno" nameComboMese="mese" className="w-2/3" disableMonth={tipoFileSel === 'NATIVO_STORICO_ANNO'}/>
                            </div>

                            <div className="flexRowWrapFull mt-3">

                                <div className="w-1/3 pr-2 pt-2">

                                    <FileDropZone droppedFiles={selectedFile} setDroppedFiles={setSelectedFile} accept="text/plain"/>

                                    {/*{open && (
                                                      <Portal>
                                                          <ConfirmDelete onCancel={() => !open} onConfirm={() => !open}/>
                                                      </Portal>
                                                  )}*/}
                                </div>

                                <div className="w-1/3 sm:pl-2">
                                    <label htmlFor="tipoFile" className="mb-1 block font-medium">Tipo file</label>
                                    <RadioInput className="!mb-0"
                                                label="Mese corrente"
                                                name="tipoFile"
                                                id="file_nativo"
                                                register={register}
                                                registerOptions={Validation.required}
                                                value="NATIVO"
                                    />
                                    <RadioInput className="!mb-0"
                                                label="Storico (singolo mese)"
                                                name="tipoFile"
                                                id="file_storico"
                                                register={register}
                                                registerOptions={Validation.required}
                                                value="NATIVO_STORICO"
                                    />
                                    <RadioInput
                                        label="Storico (intero anno)"
                                        name="tipoFile"
                                        id="file_storico_anno"
                                        register={register}
                                        registerOptions={Validation.required}
                                        value="NATIVO_STORICO_ANNO"
                                    />
                                    {errors && errors.tipoFile && <p className="text-rose-700">Specificare una tipologia!</p>}
                                </div>

                                <div className="w-1/3 sm:pl-2">
                                    <label className="mb-1 block font-medium">Altre opzioni</label>
                                    <CheckboxEx name="primoImport"
                                                control={control}
                                                label="Prima importazione"/>
                                    <CheckboxEx name="fissaRMLVariate"
                                                control={control}
                                                label="Imposta retribuzioni come &quot;variate&quot;"
                                                disabled={!selPrimoImport}/>
                                    <CheckboxEx name="noCessati" disabled
                                                control={control}
                                                label="Escludi cessati"/>
                                </div>
                            </div>
                        </>
                    </DisclosureEx>
                </div>
            </AziendaNavContainer>
        </Loading>
    )
}
export default ImportPVA;